import { useContext, useEffect, useRef } from "react";

import { DiscoveryContext } from "./discovery-context";
import api from "../../BrandOnBoarding/api";
import { AuthContext } from "../../context/auth-context";

export default function useGeneratePreCategoryDimensions() {
  const discoveryCtx = useContext(DiscoveryContext);
  const abortControllerRef = useRef();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (discoveryCtx.abort_launch) {
      discoveryCtx.updatePreCategoryDimensions([]);
    }
  }, [discoveryCtx.abort_launch]);

  async function generatePreCategoryDimensions(category) {
    abortControllerRef.current = new AbortController();
    try {
      const response = await api.post(
        "/metrics/generate-category-dimensions?return_sources=false",
        {
          llm: "gpt-4o-mini",
          category: category,
          language_id: discoveryCtx.language == "it" ? 2 : 1,
          customer_id: user.customer_id
        },
        {
          signal: abortControllerRef.current.signal,
        }
      );
      discoveryCtx.updatePreCategoryDimensions(response.data);
    } catch (error) {
      console.error("Error getting taxonomies:", error);
    }
  }

  return {
    preDimensions: discoveryCtx.pre_category_dimensions,
    generatePreCategoryDimensions,
  };
}
